@use '../../../../design-tokens/border-radius/border-radius' as *;
@use '../../../../design-tokens/typography/typography' as *;

@layer design-system {
  .legendRoot {
    box-shadow: var(--elevation-strong);
    background: var(--surface-default);
    padding: 12px 8px;
    display: flex;
    flex-direction: column;
    pointer-events: none;
    border-radius: border-radius(r1);
    min-width: 240px;
  }

  .title {
    @include typography-v2-title-sm;
    margin-bottom: 8px;
    padding: 0 4px;
  }

  .list {
    display: flex;
    flex-direction: column;
  }

  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px;
  }

  .itemHovered {
    background-color: var(--surface-active);
    border-radius: border-radius(r1);
  }

  .asset {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }

  .dot {
    width: 8px;
    height: 8px;
    border-radius: border-radius(full);
    background-color: var(--text-default);
  }

  .label {
    @include typography-v2-body-xs;
    color: var(--text-default);
  }

  .value {
    font-family: var(--font-roboto-mono);
    @include typography-v2-body-xs;
    color: var(--text-default);
  }
}
